export default __webpack_public_path__ + "static/media/orderSuccess.7733f7f7.png";